import { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { GET_DETAILDATA } from "../../actions";
import api from "../../utils/axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { downloadUrl, calendarFormat } from "../Settings/Config";
import { encodeValue, showLoader, hideLoader, showAlert, showDate, showDrobdownValue, calculateYMD } from "../Settings/Settings";
import logo from "../../assets/images/brand/nautilusshipping.jpeg";
import noImage from "../../assets/images/faces/1.jpg";
import otherpracticalExp from "./evaluation.json";
import "../../common/css/application.css";
const module = "candidate";

let documentType = [
  { key: "passport", name: "PASSPORT" },
  { key: "nationalcdc", name: "NATIONAL LICENSE" },
  { key: "seamanid", name: "SEAFARER ID (Indos)" },
  { key: "coc", name: "COC" },
  { key: "tankerany", name: "Tanker If any" },
  { key: "aff_fpff", name: "AFF / FPFF" },
  { key: "pst_pscrb", name: "PST / PSCRB" },
  { key: "medicare", name: "MEDICARE / MFA / EFA" },
  { key: "pssr", name: "PSSR" },
  { key: "stsdsd", name: "STSDSD / SSO" },
  { key: "watchkeeping", name: "WATCH KEEPING / COP" },
  
];

class Form extends Component {
  constructor(props) {
    super(props);
    const candidateID = this.props.match.params?.candidateID ?? "";
    const params = new URLSearchParams(this.props.location.search);
    const viewid = params.get("id") || "";
    this.state = {
      candidateID,
      viewid,
      viewType:(this.props.match.path==="/candidate/application/:candidateID/view")?'view':'edit',
      pageloading: true,
      detaildata: [],
      candidateDetails: "",
      candidatendk: [],
      candidatedocuments: [],
      candidateseaservice: [],
      candidatecontracts:[],
      countryList: [],
      rankList: [],
      photoUrl: "",
      dateNow: new Date(),
      otherpracticalExp,
      evaluvartionDate: new Date(),
      finalExperience:[],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
    this.handleChangeNDKText = this.handleChangeNDKText.bind(this);
  }

  componentDidMount() {
    $("body").addClass("application");
    if (this.state.candidateID !== "") {
      const params = {
        params: "",
        url: `${module}/detail/${encodeValue(this.state.candidateID)}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);

      api
        .get(`candidatendk?candidateId=${this.state.candidateID}&limit=100`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ candidatendk: res.data.result });
          }
        })
        .catch((err) => {
          console.error(err);
        });

      api
        .get(`candidatedocuments?candidateId=${this.state.candidateID}&limit=100`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ candidatedocuments: res.data.result });
          }
        })
        .catch((err) => {
          console.error(err);
        });

        api
        .get(`candidatecontract?candidateId=${this.state.candidateID}&limit=100`)
        .then((res) => {
          if (res.data.status === "ok") {
            console.log(res.data.result, 'candidatecontractscandidatecontracts')
            const sortedData = res.data.result
            .filter(item =>
              item.sign_off !== null &&
              item.sign_off !== undefined &&
              item.sign_off !== '' &&
              !item.sign_off.startsWith('1970-01-01')
            )
            .sort((a, b) => new Date(a.sign_on) - new Date(b.sign_on));
           
            this.setState({ candidatecontracts: sortedData }, ()=> {
                this.finalExperience()
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });

      api
        .get(`candidateseaservice?candidateId=${this.state.candidateID}&limit=100`)
        .then((res) => {
          if (res.data.status === "ok") {
            const sortedData = res.data.result.sort((a, b) => new Date(a.from1) - new Date(b.from1));
            this.setState({ candidateseaservice: sortedData }, ()=> {
              this.finalExperience()
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });

      api
        .get(`rank/dropdown`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ rankList: res.data.result });
          }
        })
        .catch((err) => {
          console.error(err);
        });
      api
        .get("others/countrylist")
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ countryList: res.data.result });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.candidateID !== "") {
      this.setState({ detaildata: nextProps.detaildata, pageloading: false }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          let result = nextProps.detaildata[0].result;
          result.c_rank = result.c_rank !== "" ? { label: result.c_rank, value: result.c_rank } : "";
          this.setState({ candidateDetails: result }, () => {
            this.checkImages();
          });
        }
      });
    }
  }

  finalExperience() {
    const contracts = (this.state.candidatecontracts || []).map((item) => ({
      ...item,
      arrayType: "first",
      sortDate: item.sign_on,
    }));
    const seaservices = (this.state.candidateseaservice || []).map((item) => ({
      ...item,
      arrayType: "second",
      sortDate: item.from1,
    }));
    const merged = [...contracts, ...seaservices].sort((a, b) => new Date(a.sortDate) - new Date(b.sortDate));
    this.setState({ finalExperience: merged });
    console.log(merged, 'mergedmerged')
    this.setState({finalExperience:merged})
  }
  checkImages() {
    const photos = this.state.candidateDetails.photos ? `${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}` : null;
    if (photos !== "" && photos !== null) {
      fetch(`${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}`, {
        method: "HEAD",
      })
        .then((res) => {
          if (res.ok) {
            this.setState({ photoUrl: `${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}` });
          } else {
          }
        })
        .catch(() => {
          console.log("❌ Error — server unreachable or CORS blocked");
        });
    }
  }

  handleChangeText(event) {
    if (this.state.viewid === "") {
      const name = event.target.name;
      const value = event.target.value;
      this.setState((prev) => ({
        candidateDetails: {
          ...prev.candidateDetails,
          [name]: value,
        },
      }));
    }
  }
  handleChangeNDKText = (event) => {
    if (this.state.viewid === "") {
      const { name, value } = event.target;
      let candidatendk__ = [...this.state.candidatendk];
      if (candidatendk__.length > 0) {
        candidatendk__[0] = {
          ...candidatendk__[0],
          [name]: value,
        };
        this.setState({
          candidatendk: candidatendk__,
        });
      }
    }
  };
  handleSelectChangeNDK = (name, value) => {
    if (this.state.viewid === "") {
      let candidatendk__ = [...this.state.candidatendk];
      if (candidatendk__.length > 0) {
        candidatendk__[0] = {
          ...candidatendk__[0],
          [name]: value.label,
        };
        this.setState({
          candidatendk: candidatendk__,
        });
      }
    }
  };

  handleChangeDocText = (documentName, event) => {
    if (this.state.viewid === "") {
      const { name, value } = event.target;
      this.updateDoc(documentName, name, value);
    }
  };
  handleChangeDocSelect = (documentName, name, value) => {
    if (this.state.viewid === "") {
      this.updateDoc(documentName, name, value);
    }
  };

  updateDoc(documentName, name, value) {
    let candidatedocuments__ = [...this.state.candidatedocuments];
    const index = candidatedocuments__.findIndex((item) => item.document === documentName.toUpperCase());

    if (index >= 0) {
      // Update existing object
      candidatedocuments__[index] = {
        ...candidatedocuments__[index],
        [name]: value,
      };
    } else {
      // Add new object
      let newData = {
        id: "",
        document: documentName.toUpperCase(),
        document_number: "",
        issue_date: "",
        expiry_date: "",
        issue_place: "",
        document_files: "",
        stcw: "No",
      };
      candidatedocuments__.push({ ...newData, [name]: value });
    }
    this.setState({
      candidatedocuments: candidatedocuments__,
    });
  }

  handleSelectChangeSee = (updindex, name, value) => {
    this.updateSeeService(updindex, name, value);
  };

  handleChangeTextSee = (updindex, event) => {
    const { name, value } = event.target;
    this.updateSeeService(updindex, name, value);
  };

  updateSeeService = (updindex, name, value) => {
    let candidateseaservice_ = [...this.state.candidateseaservice];
    if (candidateseaservice_[updindex]) {
      // Update existing row
      candidateseaservice_[updindex] = {
        ...candidateseaservice_[updindex],
        [name]: value,
      };
    } else {
      // Add new row
      let newData = {
        id: "",
        company: "",
        rank: "",
        vessel: "",
        type: "",
        from1: "",
        to1: "",
        total_MMDD: "",
        Flag: "",
        KWT: "",
        Engine: "",
        DWT: "",
        reason_for_sign_off: "",
        GRT: "",
      };

      candidateseaservice_.push({
        ...newData,
        [name]: value,
      });
    }

    this.setState({
      candidateseaservice: candidateseaservice_,
    });
  };

  handleSelectChange(name, value) {
    if (this.state.viewid === "") {
      if (name === "m_status") {
        this.setState((prev) => ({
          candidateDetails: {
            ...prev.candidateDetails,
            [name]: value.value,
          },
        }));
      } else if (name === "nationality") {
        this.setState((prev) => ({
          candidateDetails: {
            ...prev.candidateDetails,
            nationalityName: value.label,
            nationality: value.value,
          },
        }));
      } else {
        this.setState((prev) => ({
          candidateDetails: {
            ...prev.candidateDetails,
            [name]: value,
          },
        }));
      }
    }
  }

  submitForm() {
    let error = 0;
    if (error === 0) {
      const candidateseaservice___ = this.state.candidateseaservice.map((item)=> {
        const total_MMDD = calculateYMD(item.from1, item.to1);
        console.log(total_MMDD, 'total_MMDDtotal_MMDD')
        item.total_MMDD = total_MMDD;
        return item;
      })
      


      const postObject = {
        candidateID: this.state.candidateID,
        candidateDetails: JSON.stringify(this.state.candidateDetails),
        candidatendk: JSON.stringify(this.state.candidatendk),
        candidatedocuments: JSON.stringify(this.state.candidatedocuments),
        candidateseaservice: JSON.stringify(candidateseaservice___),
      };
      showLoader("saveDiscussion");
      const post_url = `${module}/updateApplication/${this.state.candidateID}`;

      api
        .put(post_url, postObject)
        .then((res) => {
          hideLoader("saveDiscussion");
          const errMsg = res.data.message;
          if (res.data.status === "ok") {
            showAlert("Success", errMsg, "success", "No");
          } else {
            showAlert("Error", errMsg, "error", "No");
          }
        })
        .catch((err) => {
          hideLoader("saveDiscussion");
          const errMsg = err.response.data?.message || err?.message;
          showAlert("Error", errMsg, "error", "No");
          console.error(err);
        });
    } else {
      setTimeout(() => {
        const el = document.getElementsByClassName("text-danger")[0];
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 1000);
    }
  }

  render() {
    const cDetails = this.state.candidateDetails;
    const candidatendk = this.state.candidatendk.length > 0 ? this.state.candidatendk[0] : [];
    const candidatedocuments = this.state.candidatedocuments;
    const candidateseaservice = this.state.candidateseaservice;
    const nationalityName = cDetails.nationalityName || "";
    const nationality = cDetails.nationality || "";
    const nationalityName_ = nationalityName !== "" && nationality !== "" ? showDrobdownValue(nationalityName, nationality) : "";
    const viewType = this.state.viewType;
    const m_status_ = cDetails.m_status || "";
    const m_status = (m_status_!=="" && m_status_!==null)?{label:m_status_, value:m_status_}:''
    let getDocDetails = (candidatedocuments.length>0)?candidatedocuments.filter((c) => c.document?.toUpperCase().includes('CDC')):[];
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <div className="container evaluation-form mt-4">
              <div className="main-container">
                <div className="header-row">
                  <div className="logo-col">
                    <div className="logo-main">
                      <img src={logo} alt="Nautilus Shipping India Pvt Ltd" />
                    </div>
                    <div className="company-name">Nautilus Shipping India Pvt Ltd</div>
                  </div>

                  <div className="title-col">
                    <h1 className="form-title">APPLICATION FOR EMPLOYMENT</h1>
                    <div className="title-underline"></div>
                  </div>

                  <div className="info-col">
                    <div className="info-box">
                      <table className="info-table">
                        <tbody>
                          <tr>
                            <td>
                              <i className="fa fa-file"></i> Form Number
                            </td>
                            <td>: OFF 02</td>
                          </tr>
                          <tr>
                            <td>
                              <i className="fa fa-id-card"></i> RPSL Number
                            </td>
                            <td>: RPSL-CHN-012</td>
                          </tr>
                          <tr>
                            <td>
                              <i className="fa fa-history"></i> Revision No
                            </td>
                            <td>: 00</td>
                          </tr>
                          <tr>
                            <td>
                              <i className="fa fa-calendar"></i> Date
                            </td>
                            <td>: {showDate(new Date())}</td>
                          </tr>
                          <tr>
                            <td>
                              <i className="fa fa-file"></i> Page
                            </td>
                            <td>: Page 1 of 1</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="section-box">
                  <div className="section-header">
                    <div className="section-icon">
                      <i className="fa fa-user"></i>
                    </div>
                    <h2 className="section-title">PERSONAL INFORMATION</h2>
                    <div className="section-line"></div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-9">
                      <div className="form-row">
                        <div className="form-group col-6">
                          <label className="form-label">Position applied for</label>
                          {viewType==='edit' ?(
                          <Select
                            value={cDetails.c_rank ?? ""}
                            onChange={this.handleSelectChange.bind(this, "c_rank")}
                            placeholder="Select Position applied for"
                            isClearable={true}
                            options={this.state.rankList}
                          />):(<span>{cDetails.c_rank?.label ?? ""}</span>)}
                        </div>

                        <div className="form-group col-6">
                          <label className="form-label">
                            Availability Date <span className="text-danger">*</span>
                          </label>
                          {viewType==='edit' ?(
                          <div className="datepicker-wrapper">
                            <i className="fa fa-calendar calendar-icon" aria-hidden="true"></i>
                            <DatePicker
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              placeholderText="Select Availability Date"
                              className="form-control  datepicker-input"
                              onKeyDown={(e) => e.preventDefault()}
                              selected={cDetails?.avb_date && cDetails?.avb_date !== "" && cDetails?.avb_date !== "1970-01-01" ? new Date(cDetails.avb_date) : ""}
                              dateFormat={calendarFormat}
                              onChange={this.handleSelectChange.bind(this, "avb_date")}
                              isClearable={false}
                            />
                          </div>):(<span>{showDate(cDetails?.avb_date)}</span>)}
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col-6">
                          <label className="form-label">
                            Surname<span className="lbl-error">*</span>
                          </label>
                          {viewType==='edit' ?(
                          <input type="text" className="form-control upper-case" placeholder="Surname" name="lname" value={cDetails?.lname} onChange={this.handleChangeText} />):(<span>{cDetails?.lname}</span>)}
                        </div>
                        <div className="form-group col-6">
                          <label className="form-label">
                            First Name<span className="lbl-error">*</span>
                          </label>
                          {viewType==='edit' ?(
                          <input type="text" className="form-control upper-case" placeholder="First Name" name="fname" value={cDetails?.fname} onChange={this.handleChangeText} />):(<span>{cDetails?.fname}</span>)}
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col-6">
                          <label className="form-label">Date of Birth</label>
                          {viewType==='edit' ?(
                          <div className="datepicker-wrapper">
                            <i className="fa fa-calendar calendar-icon" aria-hidden="true"></i>
                            
                            <DatePicker
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              placeholderText="Select Date of Birth"
                              className="form-control  datepicker-input"
                              onKeyDown={(e) => e.preventDefault()}
                              selected={cDetails?.dob && cDetails?.dob !== "" && cDetails?.dob !== "1970-01-01" ? new Date(cDetails.dob) : ""}
                              dateFormat={calendarFormat}
                              onChange={this.handleSelectChange.bind(this, "dob")}
                              isClearable={false}
                              maxDate={new Date()}
                            />
                          </div>
                          ):(<span>{showDate(cDetails?.dob)}</span>)}
                        </div>
                        <div className="form-group col-6">
                          <label className="form-label">
                            Place of Birth<span className="lbl-error">*</span>
                          </label>
                          {viewType==='edit' ?(
                          <input type="text" className="form-control upper-case" placeholder="Place of Birth" name="birth_place" value={cDetails?.birth_place} onChange={this.handleChangeText} />):(<span>{cDetails?.birth_place}</span>)}
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col-6">
                          <label className="form-label">Nationality</label>
                          {viewType==='edit' ?(
                          <Select
                            value={nationalityName_}
                            onChange={this.handleSelectChange.bind(this, "nationality")}
                            placeholder="Select Nationality"
                            isClearable={true}
                            options={this.state.countryList}
                          />):(<span>{(nationalityName_.label || '').toUpperCase()}</span>)}
                        </div>
                        <div className="form-group col-6">
                          <label className="form-label">Marital Status</label>
                          {viewType==='edit' ?(
                          <Select
                            value={m_status}
                            onChange={this.handleSelectChange.bind(this, "m_status")}
                            placeholder="Select Marital Status"
                            isClearable={true}
                            options={[
                              { label: "SINGLE", value: "SINGLE" },
                              { label: "MARRIED", value: "MARRIED" },
                              { label: "DIVORCED", value: "DIVORCED" },
                              { label: "WIDOW", value: "WIDOW" },
                            ]}
                          />):(<span>{m_status?.label || ''}</span>)}
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="upload-wrapper">
                        {viewType==='edit' ?(
                          <>
                           <div className="upload-icon-main">
                          <i className="fa fa-file-contract"></i>
                        </div>
                        <button type="button" className="upload-btn">
                          Choose File
                        </button>
                        <div className="upload-desc">
                          JPG, PNG or PDF
                          <br />
                          Max. 2MB
                        </div></>
                        ):(
                           <img src={this.state.photoUrl || noImage} alt="profile" className="photo" />
                        )}
                       
                       
                      </div>
                    </div>
                  </div>

                  <div className="form-row mt-1">
                    <div className="form-group col-12">
                      <label className="form-label">Address</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="Address" name="c_ad1" value={cDetails?.c_ad1} onChange={this.handleChangeText} />):(<span>{cDetails?.c_ad1}</span>)}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-6">
                      <label className="form-label">Nearest Airport</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="Nearest Airport" name="nearestAirport" value={cDetails?.nearestAirport} onChange={this.handleChangeText} />):(<span>{cDetails?.nearestAirport}</span>)}
                    </div>
                    <div className="form-group col-6">
                      <label className="form-label">No. of Children</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="No. of Children" name="totalChild" value={cDetails?.totalChild} onChange={this.handleChangeText} />):(<span>{cDetails?.totalChild}</span>)}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-6">
                      <label className="form-label">Contact</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="Contact" name="c_mobi1" value={cDetails?.c_mobi1} onChange={this.handleChangeText} />):(<span>{cDetails?.c_mobi1}</span>)}
                    </div>
                    <div className="form-group col-6">
                      <label className="form-label">Weight</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="Weight" name="weight" value={cDetails?.weight} onChange={this.handleChangeText} />):(<span>{cDetails?.weight}</span>)}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-6">
                      <label className="form-label">Height</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="Height" name="height" value={cDetails?.height} onChange={this.handleChangeText} />):(<span>{cDetails?.height}</span>)}
                    </div>
                    <div className="form-group col-6">
                      <label className="form-label">Boiler Suit size</label>
                      {viewType==='edit' ?(<input
                        type="text"
                        className="form-control upper-case"
                        placeholder="Boiler Suit size"
                        name="boiler_suit_size"
                        value={cDetails?.boiler_suit_size}
                        onChange={this.handleChangeText}
                      />):(<span>{cDetails?.boiler_suit_size}</span>)}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-6">
                      <label className="form-label">Safety Shoe Size</label>
                      {viewType==='edit' ?(<input
                        type="text"
                        className="form-control upper-case"
                        placeholder="Safety Shoe Size"
                        name="safety_shoe_size"
                        value={cDetails?.safety_shoe_size}
                        onChange={this.handleChangeText}
                      />):(<span>{cDetails?.safety_shoe_size}</span>)}
                    </div>

                    <div className="form-group col-6">
                      <label className="form-label">Sailed with Nautilus</label>
                      <div className={`d-flex gap-4 `}>1 days</div>
                    </div>
                  </div>
                </div>
                <div className="section-box">
                  <div className="section-header">
                    <div className="section-icon">
                      <i className="fa fa-user"></i>
                    </div>
                    <h2 className="section-title">NEXT OF KIN</h2>
                    <div className="section-line"></div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-6">
                      <label className="form-label">Name</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="Name" name="kin_name" value={candidatendk?.kin_name} onChange={this.handleChangeNDKText} />):(<span>{candidatendk?.kin_name}</span>)}
                    </div>

                    <div className="form-group col-6">
                      <label className="form-label">Relation</label>
                      {viewType==='edit' ?(<Select
                        value={candidatendk?.kin_relation ? { label: candidatendk?.kin_relation, value: candidatendk?.kin_relation.toUpperCase() } : ""}
                        onChange={this.handleSelectChangeNDK.bind(this, "kin_relation")}
                        placeholder="Select Relation"
                        isClearable={true}
                        options={[
                          { label: "Father", value: "FATHER" },
                          { label: "Mother", value: "MOTHER" },
                          { label: "Son", value: "SON" },
                          { label: "Daughter", value: "DAUGHTER" },
                          { label: "Brother", value: "BROTHER" },
                          { label: "Sister", value: "SISTER" },
                          { label: "Husband", value: "HUSBAND" },
                          { label: "Wife", value: "WIFE" },
                          { label: "Mother-in-law", value: "MOTHER-IN-LAW" },
                          { label: "Father-in-law", value: "FATHER-IN-LAW" },
                          { label: "Uncle", value: "UNCLE" },
                          { label: "Aunt", value: "AUNT" },
                          { label: "Nephew", value: "NEPHEW" },
                          { label: "Niece", value: "NIECE" },
                        ]}
                      />):(<span>{candidatendk?.kin_relation?.label || candidatendk?.kin_relation}</span>)}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-6">
                      <label className="form-label">Contact: Mobile / Tel</label>
                      {viewType==='edit' ?(<input
                        type="text"
                        className="form-control upper-case"
                        placeholder="Contact: Mobile / Tel"
                        name="kin_contact_number"
                        value={candidatendk?.kin_contact_number}
                        onChange={this.handleChangeNDKText}
                      />):(<span>{candidatendk?.kin_contact_number}</span>)}
                    </div>

                    <div className="form-group col-6">
                      <label className="form-label">Email</label>
                      {viewType==='edit' ?(<input type="text" className="form-control upper-case" placeholder="Email" name="kin_email" value={candidatendk?.kin_email} onChange={this.handleChangeNDKText} />):(<span>{candidatendk?.kin_email}</span>)}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-12">
                      <label className="form-label">Address</label>
                      {viewType==='edit' ?(
                      <input
                        type="text"
                        className="form-control upper-case"
                        placeholder="Address"
                        name="kin_contact_address"
                        value={candidatendk?.kin_contact_address}
                        onChange={this.handleChangeNDKText}
                      />):(<span>{candidatendk?.kin_contact_address}</span>)}
                    </div>
                  </div>
                </div>

                <div className="section-box pb-0">
                  <div className="section-header">
                    <div className="section-icon">
                      <i className="fa fa-file"></i>
                    </div>
                    <h2 className="section-title">DOCUMENTS</h2>
                    <div className="section-line"></div>
                  </div>

                  <div className="table-container mb-0" >
                    <table cellPadding={5}>
                      <thead>
                        <tr>
                          <th style={{ width: "20%" }}>Document</th>
                          <th style={{ width: "20%" }}>Document Numbers</th>
                          <th style={{ width: "20%" }}>Date Issued</th>
                          <th style={{ width: "20%" }}>Place Issued</th>
                          <th style={{ width: "20%" }}>Valid Until</th>
                        </tr>
                      </thead>
                      <tbody>
                        {documentType.map((item, index) => {
                          let displayLabel = item.name;
                          let getDocDetails = candidatedocuments.find((c) => c.document === item.name.toUpperCase());
                          let displayLabel_ = "";
                          let displayValue = "";
                          if (item.key === "tankerany") {
                            displayLabel_ = [
                              { label: "DCE OIL", value: "DCE OIL" },
                              { label: "DCE GAS", value: "DCE GAS" },
                              { label: "DCE CHEM", value: "DCE CHEM" },
                            ];
                            if (!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "DCE OIL");
                              if (getDocDetails) {
                                displayValue = { label: "DCE OIL", value: "DCE OIL" };
                              }
                            }
                            if (!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "DCE GAS");
                              if (getDocDetails) {
                                displayValue = { label: "DCE OIL", value: "DCE OIL" };
                              }
                            }
                            if (!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "DCE CHEM");
                              if (getDocDetails) {
                                displayValue = { label: "DCE OIL", value: "DCE OIL" };
                              }
                            }
                          }else if(item.key==='pst_pscrb') {
                            getDocDetails = candidatedocuments.find((c) => c.document === "PST");
                            if(!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "PSCRB");
                            }
                          }else if(item.key==='aff_fpff') {
                            getDocDetails = candidatedocuments.find((c) => c.document === "AFF");
                            if(!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "FPFF");
                            }
                          } else if(item.key==='medicare') {
                            getDocDetails = candidatedocuments.find((c) => c.document === "MEDICARE");
                            if(!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "MFA");
                            }
                            if(!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "EFA");
                            }
                          }else if(item.key==='stsdsd') {
                            getDocDetails = candidatedocuments.find((c) => c.document === "STSDSD");
                            if(!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "SSO");
                            }
                          } else if(item.key==='watchkeeping') {
                            getDocDetails = candidatedocuments.find((c) => c.document === "WATCH KEEPING");
                            if(!getDocDetails) {
                              getDocDetails = candidatedocuments.find((c) => c.document === "COP");
                            }
                          } 
                       
                          return (
                            <tr key={index}>
                              <td className="td-text">
                                {item.key === "tankerany" ? (
                                  viewType==='edit' ?(
                                  <Select
                                    value={displayValue}
                                    onChange={this.handleChangeDocSelect.bind(this, displayLabel, "tankerany")}
                                    placeholder="Tanker If any"
                                    isClearable={true}
                                    options={displayLabel_}
                                  />):(displayValue?.value || '')
                                ) : (
                                  displayLabel
                                )}
                              </td>
                              <td>
                                {viewType==='edit' ?(<input
                                  type="text"
                                  className="form-control upper-case"
                                  placeholder="Numbers"
                                  name="document_number"
                                  value={getDocDetails?.document_number}
                                  onChange={this.handleChangeDocText.bind(this, displayLabel)}
                                />):(getDocDetails?.document_number || <>&nbsp;</>)}
                              </td>
                              <td>
                                {viewType==='edit' ?(<DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  placeholderText="Date Issued"
                                  className="form-control"
                                  onKeyDown={(e) => e.preventDefault()}
                                  selected={getDocDetails?.issue_date && getDocDetails?.issue_date !== "" && getDocDetails?.issue_date !== "1970-01-01" ? new Date(getDocDetails.issue_date) : ""}
                                  dateFormat={calendarFormat}
                                  onChange={this.handleChangeDocSelect.bind(this, displayLabel, "issue_date")}
                                  isClearable={false}
                                  maxDate={new Date()}
                                />):(showDate(getDocDetails?.issue_date))}
                              </td>
                              <td>
                                {viewType==='edit' ?(<input
                                  type="text"
                                  className="form-control upper-case"
                                  placeholder="Place Issued"
                                  name="issue_place"
                                  value={getDocDetails?.issue_place}
                                  onChange={this.handleChangeDocText.bind(this, displayLabel)}
                                />):(getDocDetails?.issue_place)}
                              </td>
                              <td>
                                {viewType==='edit' ?(<DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  placeholderText="Valid Until"
                                  className="form-control"
                                  onKeyDown={(e) => e.preventDefault()}
                                  selected={getDocDetails?.expiry_date && getDocDetails?.expiry_date !== "" && getDocDetails?.expiry_date !== "1970-01-01" ? new Date(getDocDetails.expiry_date) : ""}
                                  dateFormat={calendarFormat}
                                  onChange={this.handleChangeDocSelect.bind(this, displayLabel, "expiry_date")}
                                  isClearable={false}
                                  minDate={getDocDetails?.issue_date && getDocDetails?.issue_date !== "" && getDocDetails?.issue_date !== "1970-01-01" ? new Date(getDocDetails.issue_date) : ""}
                                />):(showDate(getDocDetails?.expiry_date))}
                              </td>
                            </tr>
                          );
                        })}

                        {viewType!=='edit' ?(
                          getDocDetails.map((item, index)=> {
                               return (
                            <tr key={index}>
                              <td className="td-text">
                                {item.document}
                              </td>
                              <td>
                                {item?.document_number}
                              </td>
                              <td>
                                {showDate(item?.issue_date || '')}
                              </td>
                              <td>
                                {item?.issue_place}
                              </td>
                              <td>
                                {showDate(item?.expiry_date|| '')}
                              </td>
                            </tr>
                          );
    
                          })):('')
                        }

                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="section-box pb-0">
                  <div className="section-header">
                    <div className="section-icon">
                      <i className="fa fa-ship"></i>
                    </div>
                    <h2 className="section-title">PREVIOUS SEA EXPERIENCE (FOR LAST 10 YEARS)</h2>
                    <div className="section-line"></div>
                  </div>

                  <div className="table-container ">
                    <table>
                      <thead>
                        <tr>
                          <th>Company</th>
                          <th>Vessel Name</th>
                          <th>Type of Vessel</th>
                          <th>GRT</th>
                          <th>Flag</th>
                          <th>Engine</th>
                          <th>DWT</th>
                          <th>KWT</th>
                          <th>Rank</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Reason for sign off</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewType!=='edit' ?(
                          (this.state.finalExperience.length>0)?(this.state.finalExperience.map((item, index)=> {
                            if(item.arrayType==="second") {
                              return (
                                <tr key={index} style={{fontSize:'11px'}}>
                                  <td>
                                    {item?.company || ""}
                                  </td>
                                  <td>
                                    {item?.vessel || ""}
                                  </td>
                                  <td>
                                    {item?.type || ""}
                                  </td>
                                  <td>
                                    {item?.GRT || ""}
                                  </td>
                                  <td>
                                    {item?.Flag || ""}
                                  </td>
                                  <td>
                                    {item?.Engine || ""}
                                  </td>
                                  <td>
                                    {item?.DWT || ""}
                                  </td>
                                  <td>
                                    {item?.KWT || ""}
                                  </td>
                                  <td>
                                    {item?.rank || ""}
                                  </td>
                                  <td>
                                    {showDate(item?.from1 || '')}
                                  </td>
                                  <td>
                                    {showDate(item?.to1 || '')}
                                  </td>
                                  <td>
                                    {item?.reason_for_sign_off || ""}
                                  </td>
                                </tr>
                              );
                            }else {
                              return (
                            <tr key={index} style={{fontSize:'11px'}}>
                              <td>
                                {item?.company_name || ""}
                              </td>
                              <td>
                                {item?.vesselName || ""}
                              </td>
                              <td>
                                {item?.vesselType || ""}
                              </td>
                              <td>
                                {item?.vesselGRT || ""}
                              </td>
                              <td>
                                {item?.vesselFlag || ""}
                              </td>
                              <td>
                                {item?.vesselEngine || ""}
                              </td>
                              <td>
                              </td>
                              <td>
                                {item?.vesselKWT || ""}
                              </td>
                              <td>
                                {item?.rank || ""}
                              </td>
                              <td>
                                {showDate(item?.sign_on || '')}
                              </td>
                              <td>
                                {showDate(item?.sign_off || '')}
                              </td>
                              <td>
                                {item?.reason_for_sign_off || ""}
                              </td>
                            </tr>
                          );
                            }
                            
                          })):(
                            Array.from({ length: 10 }, (_, i) => {
                              return (
                            <tr key={i}>
                              <td> &nbsp;
                              </td>
                              <td>
                              </td>
                              <td>
                              </td>
                              <td>
                              </td>
                              <td>
                              </td>
                              <td>
                              </td>
                              <td>
                              </td>
                              <td>
                              </td>
                              <td>
                              </td>
                              <td>                               
                              </td>
                              <td>                               
                              </td>
                              <td>                               
                              </td>
                            </tr>
                          );
                            })
                          )
                        ):(
                        Array.from({ length: 10 }, (_, i) => {
                          const candidateseaservice_ = candidateseaservice[i] || "";

                          return (
                            <tr key={i}>
                              <td>
                                {}
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="company" value={candidateseaservice_?.company || ""} onChange={this.handleChangeTextSee.bind(this, i)} />
                                ):(candidateseaservice_?.company || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="vessel" value={candidateseaservice_?.vessel || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.vessel || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="type" value={candidateseaservice_?.type || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.type || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="GRT" value={candidateseaservice_?.GRT || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.GRT || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="Flag" value={candidateseaservice_?.Flag || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.Flag || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="Engine" value={candidateseaservice_?.Engine || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.Engine || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="DWT" value={candidateseaservice_?.DWT || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.DWT || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="KWT" value={candidateseaservice_?.KWT || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.KWT || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input type="text" className="form-control upper-case" name="rank" value={candidateseaservice_?.rank || ""} onChange={this.handleChangeTextSee.bind(this, i)} />):(candidateseaservice_?.rank || "")}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  onKeyDown={(e) => e.preventDefault()}
                                  selected={
                                    candidateseaservice_?.from1 && candidateseaservice_?.from1 !== "" && candidateseaservice_?.from1 !== "1970-01-01" ? new Date(candidateseaservice_?.from1) : ""
                                  }
                                  dateFormat={calendarFormat}
                                  onChange={this.handleSelectChangeSee.bind(this, i, "from1")}
                                  isClearable={false}
                                />):(showDate(candidateseaservice_?.from1 || ''))}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  onKeyDown={(e) => e.preventDefault()}
                                  selected={candidateseaservice_?.to1 && candidateseaservice_?.to1 !== "" && candidateseaservice_?.to1 !== "1970-01-01" ? new Date(candidateseaservice_?.to1) : ""}
                                  dateFormat={calendarFormat}
                                  onChange={this.handleSelectChangeSee.bind(this, i, "to1")}
                                  isClearable={false}
                                  minDate={
                                    candidateseaservice_?.from1 && candidateseaservice_?.from1 !== "" && candidateseaservice_?.from1 !== "1970-01-01" ? new Date(candidateseaservice_?.from1) : ""
                                  }
                                />):(showDate(candidateseaservice_?.to1 || ''))}
                              </td>
                              <td>
                                {viewType==='edit' ?(
                                <input
                                  type="text"
                                  className="form-control upper-case"
                                  name="reason_for_sign_off"
                                  value={candidateseaservice_?.reason_for_sign_off || ""}
                                  onChange={this.handleChangeTextSee.bind(this, i)}
                                />):(candidateseaservice_?.reason_for_sign_off || "")}
                              </td>
                            </tr>
                          );
                        }))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {viewType==='edit' &&
                <div className="submit-box">
                  <button type="button" className="submit-btn" onClick={this.submitForm.bind(this)}>
                    <i className="fa fa-paper-plane"></i> Submit Application
                  </button>               
                </div>
                 }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);
